import { useStyles } from "./styles";
// eslint-disable-next-line import/named
import { Grid, Table, TableHead, TableBody, TableRow, TableCell, Typography, CircularProgress, Modal, TextField, Button as MuiButton, CircularProgressProps, Box, TableFooter, TablePagination } from '@material-ui/core';
import Button from '../../components/button';
import { TableDataStruct } from 'interfaces/Datastructures';
import { useEffect, useRef, useState } from "react";
import { axiosHelperWithToken } from "utils/axios";
import { useDispatch, useSelector } from "react-redux";
import { showNotification } from "store/slices/snackbar/snackbarSlice";
import { getClientId, getSubscriptionStatus } from "store/selectors/userSelector";
import { useHistory } from "react-router";
import { StatusTypes } from "constants/StatusTypes";
import ArrowForwardIcon from '@material-ui/icons/ArrowDownward';
import CloseIcon from '@material-ui/icons/Close';
import SearchIcon from '@mui/icons-material/Search';
import { InputBase, Paper, IconButton } from "@mui/material";

function ClientDashboard() {
  const classes = useStyles();
  const axios = axiosHelperWithToken();
  const dispatch = useDispatch();
  const [tableData, setTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showInviteModal, setShowInviteModal] = useState(false);
  const [downloadProgress, setDownloadProgress] = useState(0);
  const [searchString, setSearchString] = useState('');
  const searchInput = useRef<any>();
  const history = useHistory();
  const [userDetails, setUserDetails] = useState({
    firstName: '',
    lastName: '',
    email: '',
    invited: false
  });
  // state for paginated table data
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const clientId = useSelector(getClientId);
  const isSubscriptionActive = useSelector(getSubscriptionStatus);
  function CircularProgressWithLabel(
    props: CircularProgressProps & { value: number },
  ) {
    return (
      <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        <CircularProgress variant="determinate" {...props} />
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography
            variant="caption"
            component="div"
            color="textSecondary"
          >{`${Math.round(props.value)}%`}</Typography>
        </Box>
      </Box>
    );
  }
  const cellTitles = [
    'First Name',
    'Last Name',
    'Email',
    'Type',
    'Active?'
  ];

  const keyOrder = [
    'firstName',
    'lastName',
    'email',
    'type',
    'active'
  ];

  const cellTitlesSubscriptions = [
    'Client ID',
    'Plan Type',
    'Active?'
  ];


  useEffect(() => {
    const axios = axiosHelperWithToken();
    const params = searchString === '' ? {} : { searchText: searchString }
    axios.get('/Users/clinicians', { params }).then((response) => {
      setTableData(response.data);
    }).catch(() => {
      dispatch(showNotification({ message: 'An error has occurred', variant: "error" }));
    }).finally(() => {
      setIsLoading(false);
    });
  }, [dispatch, searchString]);

  const handleChangePage = (event: any, newPage: number) => setPage(newPage);

  const handleChangeRowsPerPage = (event: any) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleSearch = () => {
    setSearchString(searchInput.current?.lastChild?.value)
    setPage(0);
  };

  const inviteUser = () => {
    axios.post('/Users/invite-clinician', {
      firstName: userDetails.firstName,
      lastName: userDetails.lastName,
      email: userDetails.email
    }).then(() => {
      dispatch(showNotification({ message: 'Invite Sent', variant: "success" }));
      setUserDetails({ ...userDetails, invited: true });
    }).catch(() => {
      dispatch(showNotification({ message: 'An error has occurred', variant: "error" }));
    }).finally(() => {
      setShowInviteModal(false);
    });
  }
  const downloadSetup = () => {
    axios.post(`/Subscription/download-lite-pacs?clientId=${clientId}`, {}, {
      responseType: 'blob',
      onDownloadProgress: (progressEvent) => {
        const progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
        setDownloadProgress(progress);

      }
    }).then((response) => {
      const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', `MommyVuePacsLite-${clientId}.zip`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    }).catch(() => {
      dispatch(showNotification({ message: 'An error has occurred', variant: "error" }));
    }).finally(() => {
      setIsLoading(false);
    });

  }
  const showSubscriptionContent = isSubscriptionActive !== StatusTypes.ACTIVE
  const nonSubscriptionStyle = { paddingTop: showSubscriptionContent ? 0 : 100 }
  return (
    <>
      {showSubscriptionContent ? <Grid xs={12} className={classes.signupBanner}>
        To use MommyVue you need an active subscription. Please click the button to finish signup.
        <Button
          text={'Add Subscription'}
          action={() => {
            history.push('/signup-payment')
          }}
          styles={{
            float: 'right',
            marginTop: -14
          }} />
      </Grid> : null}
      <Grid
        xs={10}
        className={classes.customerListViewWrapper}
        style={nonSubscriptionStyle}>
        <Modal
          open={showInviteModal}
          onClose={() => setShowInviteModal(false)}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
        >
          <div className={classes.modalBody}>
            <IconButton aria-label="close" className={classes.closeButton} onClick={() => setShowInviteModal(false)}>
              <CloseIcon />
            </IconButton>
            <Typography color="inherit" className={classes.modalTitle}>
              Add Clinician
            </Typography>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="firstName"
              label="First Name"
              name="firstName"
              value={userDetails.firstName}
              onChange={(e) => { setUserDetails({ ...userDetails, firstName: e.target.value.trim() }) }}
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="lastName"
              label="Last Name"
              name="lastName"
              value={userDetails.lastName}
              onChange={(e) => { setUserDetails({ ...userDetails, lastName: e.target.value.trim() }) }}
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="email"
              label="User Email"
              name="email"
              value={userDetails.email}
              onChange={(e) => { setUserDetails({ ...userDetails, email: e.target.value.trim() }) }}
            />
            <Button
              text={'Invite User'}
              styles={{
                marginRight: '15px',
                display: 'block',
                float: 'right'
              }}
              action={() => {
                inviteUser();
              }} />
          </div>
        </Modal>
        {!showSubscriptionContent && <div style={{ marginBottom: '20px' }}>
          <Typography component="h1" variant="h5" color="inherit" gutterBottom className={classes.usersHeader}>
            Subscriptions
          </Typography>
          <Table>
            {isLoading ? <div style={{ margin: '0 auto', textAlign: 'center' }}><CircularProgress disableShrink /></div> :
              <>
                <TableHead>
                  <TableRow>
                    {cellTitlesSubscriptions.map(titleText => {
                      return (
                        <TableCell className={classes.tableCell} key={titleText}><b>{titleText}</b></TableCell>
                      );
                    })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell className={classes.tableCell}>{clientId}</TableCell>
                    <TableCell className={classes.tableCell}>{"Mommyvue Subscription"}</TableCell>
                    <TableCell className={classes.tableCell}>{showSubscriptionContent ? "No" : "Yes"}</TableCell>
                  </TableRow>
                </TableBody>
              </>}
          </Table>
        </div>}
        {!showSubscriptionContent && <>
          <Grid container>
            <Grid xs={4}>
              {!showSubscriptionContent && (downloadProgress > 0 && downloadProgress < 100) ?
                <CircularProgressWithLabel value={downloadProgress} /> :
                !showSubscriptionContent && <MuiButton
                  color="primary"
                  startIcon={<ArrowForwardIcon />}
                  onClick={() => {
                    downloadSetup();
                  }}>
                  Download Setup

                </MuiButton>
              }

            </Grid>
            <Grid xs={4}>
              <Typography component="h1" variant="h5" color="inherit" gutterBottom className={classes.usersHeader}>
                Users
              </Typography>
            </Grid>
            <Grid xs={4}>
              {!showSubscriptionContent && <Button
                text={'Invite User'}
                styles={{
                  marginRight: '15px',
                  display: 'block',
                  float: 'right'
                }}

                action={() => {
                  setShowInviteModal(true);
                }} />}
            </Grid>
          </Grid>
          <Paper
            component="form"
            sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 400, boxShadow: 'none' }}
          >
            <InputBase type="search" id="txtSearchUsers" ref={searchInput}
              sx={{ ml: 1, flex: 1 }}
              placeholder="Search by Email/Name/Type"
              inputProps={{ 'aria-label': 'Search' }}
              onChange={(ev: any) => { if (ev.target.value === '') handleSearch() }}
              onKeyPress={(ev: any) => { if (ev.key === 'Enter') { ev.preventDefault(); handleSearch() } }}
            />
            <IconButton type="button" sx={{ p: '10px' }} aria-label="search"
              onClick={(ev: any) => { ev.preventDefault(); handleSearch() }}>
              <SearchIcon />
            </IconButton>
          </Paper>
          <Table>
            {isLoading ? <div style={{ margin: '0 auto', textAlign: 'center' }}><CircularProgress disableShrink /></div> :
              <>
                <TableHead>
                  <TableRow>
                    {cellTitles.map(titleText => {
                      return (
                        <TableCell key={titleText} className={classes.tableCell}><b>{titleText}</b></TableCell>
                      );
                    })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {!isLoading && tableData.length === 0 ?
                    <div>No results</div>
                    : null}
                  {!isLoading && tableData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((rowData: TableDataStruct, index: number) => {
                    return (
                      <TableRow key={`row${index}`}>
                        {keyOrder.map((key: string, cellIndex: number) => {
                          let value = rowData[key];
                          if (key === "active") {
                            value = rowData[key] ? "Yes" : "No"
                          }
                          return (
                            <TableCell key={`cell${cellIndex}`} className={classes.tableCell}>{value}</TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
                </TableBody>

              </>}
          </Table>
          {tableData.length > 0 && tableData.length > 5 && <TablePagination
            rowsPerPageOptions={[5, 10, 25, 50, 100]}
            component="div"
            count={tableData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />}
        </>}
      </Grid>
    </>
  )
}

export default ClientDashboard
